import { useContext } from "react";

import { Flex } from "@magnetic/flex";
import { ViewSwitcher, ViewSwitcherOption } from "@magnetic/view-switcher";

import { ThemeContext } from "src/core/themeContext";
import { Theme } from "src/gen/schema/models/auth";

const THEME_SWITCHER_OPTIONS: readonly ViewSwitcherOption[] = [
  { label: "Light", value: Theme.LIGHT.toString() },
  { label: "Dark", value: Theme.DARK.toString() }
];

const ThemeToggle = () => {
  const { theme, applyTheme } = useContext(ThemeContext);

  return (
    <Flex justify="space-between" align="center">
      <p className="item-name">Theme</p>
      <ViewSwitcher
        aria-label="Theme"
        data-qa="theme-switcher"
        onChange={(themeValue) => {
          applyTheme(Number(themeValue) as Theme, true);
        }}
        options={THEME_SWITCHER_OPTIONS}
        size="sm"
        value={theme.toString()}
      />
    </Flex>
  );
};

export { ThemeToggle };
